import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Modal,
  styled,
  Chip,
  Avatar,
  IconButton,
  FormControl,
  FormGroup,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import PageTitle from "../commoncomponents/PageTitle";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomMonthYearPicker from "../commoncomponents/CustomMonthYearPicker";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CloseButton from "../commoncomponents/CloseButton";
import CreateModal from "./CreateModal";
import dayjs from "dayjs";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

import {
  getAuthToken,
  getFacilityId,
} from "../../utility/tokenUtility";
import CustomTooltip from "../commoncomponents/CustomTooltip";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import EditModal from "./EditModal";
import CustomMultiSelect from "../commoncomponents/CustomMultiSelect";
import CustomDialog from "../commoncomponents/CustomDialog";

const StyledDayShift = styled(Typography)(({ theme }) => {
  return {
    backgroundColor: "#FEFFDD",
    borderLeft: "4px solid #8D9019",
    color: "#8D9019",
    padding: "4px 12px",
    borderRadius: "4px",
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
  };
});
const StyledNightShift = styled(Typography)(({ theme }) => {
  return {
    backgroundColor: "#DDF1FF",
    borderLeft: "4px solid #2D85C5",
    color: "#2D85C5",
    padding: "4px 12px",
    borderRadius: "4px",
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
  };
});

const StyledNotAllocated = styled(Typography)(({ theme }) => {
  return {
    backgroundColor: "#cfedce",
    borderLeft: "4px solid #2aab31",
    color: "#2aab31",
    padding: "4px 12px",
    borderRadius: "4px",
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
  };
});

const StyledOnCallChip = styled(Chip)(({ theme }) => {
  return {
    backgroundColor: "#F0F0F0",
    padding: "2px 8px",
    borderRadius: "8px",
    color: "#000",
    // height: 'auto',
    margin: 0,
    fontSize: 12,
    textTransform: "uppercase",
    "& .MuiChip-icon": {
      fontSize: 12,
      color: theme.palette.success.shade,
    },
  };
});
const StyledOffDayChip = styled(Chip)(({ theme }) => {
  return {
    backgroundColor: "#F0F0F0",
    padding: "2px 8px",
    borderRadius: "8px",
    color: "#000",
    // height: 'auto',
    margin: 0,
    fontSize: 12,
    textTransform: "uppercase",
    "& .MuiChip-icon": {
      fontSize: 12,
      color: theme.palette.error.main,
    },
  };
});

const StyledStandbyChip = styled(Chip)(({ theme }) => {
  return {
    backgroundColor: "#F0F0F0",
    padding: "2px 8px",
    borderRadius: "8px",
    color: "#000",
    // height: 'auto',
    margin: 0,
    fontSize: 12,
    textTransform: "uppercase",
    "& .MuiChip-icon": {
      fontSize: 12,
      color: "#b0b0b0",
    },
  };
});

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
};

const Day = () => (
  <Stack direction={"row"} spacing={1} alignItems={"center"}>
    <Typography
      width={12}
      height={12}
      sx={{ backgroundColor: "#B7BA62", borderRadius: "50%" }}
    ></Typography>
    <Typography color={"text.secondary"}>Day</Typography>
  </Stack>
);

const Night = () => (
  <Stack direction={"row"} spacing={1} alignItems={"center"}>
    <Typography
      width={12}
      height={12}
      sx={{ backgroundColor: "#2D85C5", borderRadius: "50%" }}
    ></Typography>
    <Typography color={"text.secondary"}>Night</Typography>
  </Stack>
);

function CalenderView() {
  const [gridApi, setGridApi] = useState(null);
  const [shiftOptions, setShiftOptions] = useState([]);
  const [dutyOptions, setDutyOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false)
  const [selectedMonthYear, setSelectedMonthYear] = useState(dayjs());
  const [workGroups, setWorkGroups] = useState([]);
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [responseWorkgroupArray, setResponseWorkgroupArray] = useState([]);
  const token = getAuthToken("id_token");
  const facilityId = getFacilityId();
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState("")
  const [selectedServices, setSelectedServices] = useState([])
  const [openValidationDialog, setOpenValidationDialog] = useState(false)
  const [contentDialog, setContentDialog] = useState("")


  const [selectedWeek, setSelectedWeek] = useState(dayjs());
  const [colDefs, setColDefs] = useState([]);
  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];

  const transformResponse = (responseArray) => {
    return responseArray.map((item) => {
      const { staffDutyRoasterDetails, ...employee } = item

      // Initialize the transformed object with employee details
      const transformedObject = {
        employee: {
          ...employee,
        },

      };

      // Process staffDutyRoasterDetails to create date-based properties
      staffDutyRoasterDetails.forEach((detail) => {
        const propName = detail.shiftdate.replace(/\//g, ""); // Remove slashes to create the property name

        transformedObject[propName] = {
          shift: detail.shifttype.toLowerCase(),
          availability: detail.stafavailability.toLowerCase(),
          fromTime: detail.shiftstarttime.slice(0, 5),
          toTime: detail.shiftendtime.slice(0, 5),
          ...detail
        };
      });

      return transformedObject;
    });
  };

  const handleDialogConfirm = () => {
    setOpenValidationDialog(false);
  };

  function isWithin90Days(date) {
    const inputDate = new Date(date); // Convert the input to a Date object
    const currentDate = new Date(); // Get the current date and time

    // Normalize the dates to YYYY-MM-DD by setting time to 00:00:00
    inputDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    // Calculate the date 90 days from the current date
    const ninetyDaysFromNow = new Date(currentDate);
    ninetyDaysFromNow.setDate(currentDate.getDate() + 89);

    // Compare the dates
    return inputDate >= currentDate && inputDate <= ninetyDaysFromNow;
}


  const handleEditModal = (data) => {

    if (data?.isValid) {
      setData(data)
      toggleEditModal(true)()
    } else {
      setOpenValidationDialog(true);
      setContentDialog("You can only edit dates from today up to 90 days in the future, including today.");
    }
  }

  const generateColumns = (startOfWeek) => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = startOfWeek.add(i, "day");
      if (i === 0) {
        setStartDate(day.format("YYYY-MM-DD"))
      } else if (i === 6) {
        setEndDate(day.format("YYYY-MM-DD"))
      }
      days.push({
        field: day.format("YYYYMMDD"), // Updated to use date format YYYY-MM-DD
        headerName: `${day.format("ddd")} ${day.format("DD")}`,
        cellRenderer: (params) => {
          const col = params?.data[params.colDef.field];
          const isValidDate = isWithin90Days(day.format("YYYY-MM-DD"))
          const data = {
            employee: params?.data?.employee,
            day: params?.data[params.colDef.field],
            date: day.format("DD/MM/YYYY"),
            isValid: isValidDate
          }
          return (
            <>
              {col ? (
                <Box my={1} onClick={() => handleEditModal(data)}>
                  {col?.shift === "day" && (
                    <StyledDayShift mb={1}>Day Shift</StyledDayShift>
                  )}
                  {col?.shift === "night" && (
                    <StyledNightShift mb={1}>Night Shift</StyledNightShift>
                  )}

                  <Stack
                    direction={"row"}
                    spacing={1}
                    useFlexGap
                    flexWrap={"wrap"}
                  >
                    <Typography color={"text.secondary"} fontSize={12}>
                      {col?.fromTime || "00:00"} to {col?.toTime || "00:00"}
                    </Typography>
                    {col?.availability === "on call" && (
                      <StyledOnCallChip
                        label={"On Call"}
                        icon={<FiberManualRecordIcon />}
                      />
                    )}
                    {col?.availability === "off duty" && (
                      <StyledOffDayChip
                        label={"Off Duty"}
                        icon={<FiberManualRecordIcon />}
                      />
                    )}
                    {col?.availability === "stand by" && (
                      <StyledStandbyChip
                        label={"Stand By"}
                        icon={<FiberManualRecordIcon />}
                      />
                    )}
                  </Stack>
                </Box>
              ) : (
                <Box my={1} onClick={() => handleEditModal(data)}>
                  <StyledNotAllocated mb={1}>Not Allocated</StyledNotAllocated>
                </Box>
              )}

            </>
          );
        },
        autoHeight: true,
      });
    }
    return days;
  };



  // Set column definitions based on the selected week
  useEffect(() => {
    const startOfWeek = selectedWeek.startOf("week");
    setColDefs([
      {
        field: "employee",
        headerName: "Employee",
        minWidth: 250,
        cellRenderer: ({ data }) => {
          return (
            <>
              <Stack py={1} direction={"row"} alignItems={"center"}>
                <Avatar
                  alt="Alqifarhan Bin"
                  src={data?.employee?.imagepath}
                  sx={{ width: 50, height: 50 }}
                />

                <Stack ml={1}>
                  <Stack direction={"row"}>
                    <Typography
                      fontSize={12}
                      color={"text.secondary"}
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "keep-all",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {data.employee.employeeName}
                    </Typography>
                  </Stack>
                  <Stack flexWrap={"wrap"}>
                    <Typography color={"primary.light"} fontWeight={500}>
                      {data.employee.empCode}
                    </Typography>
                    {data.employee.roleDesc && (
                      <Typography
                        color={"success.shade"}
                        fontWeight={500}
                        sx={{
                          whiteSpace: "normal",
                          wordBreak: "keep-all",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {data.employee.roleDesc}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </>
          );
        },
      },
      ...generateColumns(startOfWeek),
    ]);
  }, [selectedWeek]);

  useEffect(() => {
    setWorkGroupOptions(
      responseWorkgroupArray.filter((option) =>
        selectedServices.includes(option.service)
      )
    );
  }, [selectedServices, workGroups]);

  const goToPreviousWeek = () => {
    setSelectedWeek(selectedWeek.subtract(1, "week"));
    setSelectedMonthYear(selectedWeek.subtract(1, "week").format("YYYY-MM"));
  };

  const goToPreviousMonth = () => {
    const firstWeekOfPreviousMonth = selectedWeek
      .clone()
      .subtract(1, "month")
      .startOf("month");
    setSelectedWeek(firstWeekOfPreviousMonth);
    setSelectedMonthYear(firstWeekOfPreviousMonth.format("YYYY-MM"));
  };
  const goToNextWeek = () => {
    setSelectedWeek(selectedWeek.add(1, "week"));
    setSelectedMonthYear(selectedWeek.add(1, "week").format("YYYY-MM"));
  };

  const goToNextMonth = () => {
    const firstWeekOfNextMonth = selectedWeek
      .clone()
      .add(1, "month")
      .startOf("month");

    setSelectedWeek(firstWeekOfNextMonth);
    setSelectedMonthYear(firstWeekOfNextMonth.format("YYYY-MM"));
  };

  const toggleModal = (newOpen) => () => {
    setOpen(newOpen);
  };
  const toggleEditModal = (newOpen) => () => {
    setOpenEdit(newOpen);
  };





  useEffect(() => {
    if (startDate && endDate)
      fetchData()
  }, [startDate, endDate]);

  const fetchOptions = async () => {
    try {
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };

      // Make all API calls concurrently
      const [
        workgroupResponseBems,
        workgroupResponseFems,
        dutyResponse,
        shiftResponse,
      ] = await Promise.all([
        axios.get(
          `${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`,
          config
        ),
        axios.get(
          `${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`,
          config
        ),
        axios.get(`${MasterGraph}/api/masstaffavailabilities`, config),
        axios.get(`${MasterGraph}/api/masstaffshifts`, config),
      ]);

      // Process workgroup options
      setResponseWorkgroupArray([
        ...workgroupResponseBems.data.map((data) => ({
          id: data.id,
          value: `${data.wgcode} - ${data.wgdesc}`,
          label: `${data.wgcode} - ${data.wgdesc}`,
          service: "BEMS"
        })),
        ...workgroupResponseFems.data.map((data) => ({
          id: data.id,
          value: `${data.wgcode} - ${data.wgdesc}`,
          label: `${data.wgcode} - ${data.wgdesc}`,
          service: "FEMS"

        })),
      ]);

      // Process shift options
      setShiftOptions(
        shiftResponse.data.map((shift) => ({
          ...shift,
          id: shift?.id,
          label: shift?.shifttype,
          value: shift?.shifttype,
        }))
      );

      // Process duty options
      setDutyOptions(
        dutyResponse.data.map((duty) => ({
          ...duty,
          id: duty?.id,
          label: duty?.staffavailability,
          value: duty?.staffavailability,
        }))
      );
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchData = async (service) => {
    setIsLoading(true);
    try {
      // Obtain the bearer token from local storage or your state management system
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId();
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const selectedWorkgroups = workGroups.map((wg) => wg.id)

      // const response = await axios.get(`${MasterGraph}/api/GraphDutyRoster/GetDutyRosterList/${facilityId}?fromdate=${startDate}&todate=${endDate}&token=${token}`, config)
      const response = await axios.get(`${MasterGraph}/api/GraphDutyRoster/GetDutyRosterList/${facilityId}?service=[${selectedServices}]&workgroupid=[${selectedWorkgroups}]&fromdate=${startDate}&todate=${endDate}&token=${token}`, config)

      const data = transformResponse(response.data);
      setRowData(data)

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleServiceChange = (event) => {
    const { value, checked } = event.target;
    setSelectedServices((prev) =>
      checked ? [...prev, value] : prev.filter((service) => service !== value)
    );
  };

  const handleWorkGroupsChange = (newvalue) => {
    setWorkGroups(newvalue);
  };

  return (
    <>
      <PageTitle title="Staff Duty Roster" />
      <DefaultCard>
        <Stack direction="row" justifyContent={"center"} alignItems="center">
          <CustomTooltip title="Previous Month">
            <IconButton
              onClick={goToPreviousMonth}
              sx={{ borderRadius: "10%", color: "text.primary" }}
            >
              <KeyboardDoubleArrowLeftIcon />
            </IconButton>
          </CustomTooltip>

          <IconButton
            onClick={goToPreviousWeek}
            sx={{ borderRadius: "10%", color: "text.primary", mr: 2 }}
          >
            <ChevronLeftIcon />
            <Typography sx={{ fontWeight: "800" }}>Previous week</Typography>
          </IconButton>

          <CustomMonthYearPicker
            value={selectedMonthYear}
            onDateChange={(newValue) => {
              setSelectedMonthYear(newValue);
              setSelectedWeek(dayjs(`${newValue}-01`, "YYYY-MM"));
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                display: "none", // Hide the fieldset
              },
              "& .MuiInputAdornment-root": {
                display: "none", // Hide the input adornment
              },
              "& .MuiOutlinedInput-input": {
                padding: "0px",
                fontSize: "30px",
                fontWeight: "550",
                cursor: "pointer",
              },
              width: "135px",
            }}
            sxText={{
              padding: "0px",
              fontSize: "20px",
            }}
          />

          <IconButton
            onClick={goToNextWeek}
            sx={{ borderRadius: "10%", color: "text.primary", ml: 2 }}
          >
            <Typography sx={{ fontWeight: "800" }}>Next week</Typography>
            <ChevronRightIcon />
          </IconButton>
          <CustomTooltip title="Next Month">
            <IconButton
              onClick={goToNextMonth}
              sx={{ borderRadius: "10%", color: "text.primary" }}
            >
              <KeyboardDoubleArrowRightIcon />
            </IconButton>
          </CustomTooltip>
        </Stack>

        <Stack
          direction={"row"}
          alignContent={"center"}
          justifyContent={"space-between"}
        >
          <Stack direction={"row"} alignItems={"flex-end"} mb={2}>
            <Box width={150}>
              <FormControl fullWidth error={true}>
                <Box>
                  <Typography variant="labelSm">Service</Typography>
                </Box>
                <FormGroup row>
                  {serviceOptions.map((service) => (
                    <FormControlLabel
                      key={service.value}
                      control={
                        <Checkbox
                          error={true}
                          checked={selectedServices?.includes(service.value)}
                          onChange={handleServiceChange}
                          value={service.value}
                        />
                      }
                      label={service.label}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            </Box>
            <Box width={300} ml={1}>
              <CustomMultiSelect
                label="Work Group"
                values={workGroups}
                options={workGroupOptions}
                onChange={handleWorkGroupsChange}
              />
            </Box>

            <Stack
              direction={"row"}
              alignItems={"center"}
              ml={2}
              justifyContent={"space-between"}
              mb={0.5}
            >
              <Box mr={1}>
                <Button variant="contained" onClick={fetchData}>
                  Fetch
                </Button>
              </Box>
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={1}
                height={"100%"}
              >
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Typography
                    width={12}
                    height={12}
                    sx={{ backgroundColor: "#5ECBAD", borderRadius: "50%" }}
                  ></Typography>
                  <Typography color={"text.secondary"}>On Call</Typography>
                </Stack>
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Typography
                    width={12}
                    height={12}
                    sx={{ backgroundColor: "#EE6C3B", borderRadius: "50%" }}
                  ></Typography>
                  <Typography color={"text.secondary"}>Off Duty</Typography>
                </Stack>
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Typography
                    width={12}
                    height={12}
                    sx={{ backgroundColor: "#B0B0B0", borderRadius: "50%" }}
                  ></Typography>
                  <Typography color={"text.secondary"}>Stand By</Typography>
                </Stack>
              </Stack>
              <Stack
                ml={5}
                direction={"row"}
                spacing={2}
                alignItems={"center"}
                useFlexGap
                flexWrap={"wrap"}
              >
                <FormLabel>Shift:</FormLabel>
                <Day />
                <Night />
              </Stack>


            </Stack>
          </Stack>
          <Stack direction={"row"} mb={2} alignItems={"flex-end"}>
            <Button
              sx={{ paddingLeft: "10px", paddingRight: "10px" }}
              variant="contained"
              onClick={() => {
                toggleModal(true)();
              }}
            >
              <AddRoundedIcon />
              Create New Shift
            </Button>

            <RefreshExportButtons
              exportFunction={() => { }}
              exportData={[]}
              sheetname={`sample`}
              filename={`sample`}
              refData={gridApi} // Adjust as needed
              handleRefresh={fetchData}
              pagination={false}
              enableDownload={false}
            />
          </Stack>
        </Stack>

        <CustomAgGrid
          height={"600px"}
          rows={rowData}
          columns={colDefs}
          refSet={gridApi}
          setGridApi={setGridApi}
          disableFilter={true}
          sortable={false}
          resizable={false}
          isLoading={isLoading}
        />
        <Modal open={open}>
          <Box sx={ModalStyle}>
            <CreateModal
              handleModalCancel={toggleModal}
              dutyOptions={dutyOptions}
              shiftOptions={shiftOptions}
              fetch={fetchData}
            />
          </Box>
        </Modal>
        <Modal open={openEdit}>
          <Box sx={ModalStyle}>
            <EditModal
              handleModalCancel={toggleEditModal}
              data={data}
              shiftOptions={shiftOptions}
              dutyOptions={dutyOptions}
              fetch={fetchData}
            />
          </Box>
        </Modal>
        <CloseButton />
        <CustomDialog
          open={openValidationDialog}
          onConfirm={handleDialogConfirm}
          content={contentDialog}
          confirmBtn={"Ok"}
        />
      </DefaultCard>
    </>
  );
}

export default CalenderView;
